import { cn } from '@kit/ui/utils';

interface HeroBrandingProps {
  compact: boolean;
}

export function HeroBranding({ compact }: HeroBrandingProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center text-center',
        compact ? 'mb-0' : 'mb-1 sm:mb-2',
      )}
    >
      {/* Eyebrow */}
      <div
        className={cn(
          'inline-flex items-center gap-2',
          compact ? 'mb-0.5 sm:mb-1' : 'mb-4 sm:mb-6',
        )}
      >
        <span
          className={cn(
            'h-px bg-zinc-300 dark:bg-zinc-600',
            compact ? 'w-4 sm:w-6' : 'w-6 sm:w-8',
          )}
        />
        <span
          className={cn(
            'font-heading font-semibold tracking-[0.15em] text-zinc-500 uppercase dark:text-zinc-400',
            compact ? 'text-[8px] sm:text-[9px]' : 'text-[10px] sm:text-xs',
          )}
        >
          Dla lekarzy i farmaceutów
        </span>
        <span
          className={cn(
            'h-px bg-zinc-300 dark:bg-zinc-600',
            compact ? 'w-4 sm:w-6' : 'w-6 sm:w-8',
          )}
        />
      </div>

      {/* Headline */}
      <h1
        className={cn(
          'font-heading leading-[1.08] font-bold tracking-tight text-zinc-900 dark:text-white',
          compact ? 'text-2xl sm:text-4xl' : 'text-4xl sm:text-6xl md:text-7xl',
        )}
      >
        Interakcje lekowe.
        <br />
        <span className="text-zinc-300 dark:text-zinc-600">Wprost z ChPL.</span>
      </h1>
    </div>
  );
}
